import { useTranslation } from 'react-i18next'

import { WarningIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Chip, Text } from '@reveni-io/reveni-ui'

import { getExportPriceCountriesInfo } from '../helpers'
import { getExportPricesWithMostCountriesCount } from './helpers'

const ExportPrice = ({ item, product }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  if (!item?.export_details) return '-'

  const exportPriceLabel = getExportPriceCountriesInfo(item?.export_details, t)

  return (
    <>
      {getExportPricesWithMostCountriesCount(product) === item?.export_details?.length ? (
        <Text type="bodyMRegular">{exportPriceLabel}</Text>
      ) : (
        <Chip
          label={<span data-testid="export-price-warning-chip">{exportPriceLabel}</span>}
          backgroundColor={theme.colors.warning.surface}
          color={theme.colors.warning.onSurface}
          Icon={WarningIcon}
        />
      )}
    </>
  )
}

export default ExportPrice
